import ImageViewer from './src/image-viewer.mjs';
export { imageViewerEmits, imageViewerProps } from './src/image-viewer2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElImageViewer = withInstall(ImageViewer);

export { ElImageViewer, ElImageViewer as default };
//# sourceMappingURL=index.mjs.map
